import { rosterAPI } from '@/providers/apis/roster/roster';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'enrollment-list',
})

export default class EnrollmentList extends Vue {

    // ------------------------------------------------------------------------
    // Properties
    @Prop()
    private sourceId: any;

    private  filter: any = null;

    private orgsDetails: any = [];

    // ---------------------------------------------------------------------------------
    // Hooks



    // ------------------------------------------------------------------------------
    // Methods

}
